// src/api/apiPrivate.js
import axios from 'axios'
import { EventBus } from '@/utils/eventBus'
// import { resolveApiBaseURL } from '@/utils/gatewayState'


const apiPrivate = axios.create({
    baseURL: process.env.VUE_APP_API_GATEWAY,
    timeout: 30000,
    withCredentials: true,
})

// const apiPrivate = axios.create({
//     timeout: 30000,
//     withCredentials: true
// })

// apiPrivate.interceptors.request.use(config => {
//     config.baseURL = resolveApiBaseURL()
//     return config
// })

let isRefreshing = false
let failedQueue = []

const processQueue = (error = null) => {
    failedQueue.forEach(p => error ? p.reject(error) : p.resolve())
    failedQueue = []
}

export const privateRequest = async (
    url,
    method,
    data = null,
    showLoading = true
) => {
    if (showLoading) EventBus.showLoading()

    try {
        const res = await apiPrivate({ url, method, data })
        return res.data
    } finally {
        if (showLoading) EventBus.hideLoading()
    }
}

/* ===== Request interceptor ===== */
apiPrivate.interceptors.request.use(config => {
    if (config.url.includes('/auth/refresh')) {
        delete config.headers.Authorization
        return config
    }

    const token = localStorage.getItem('accessToken')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})

// apiPrivate.interceptors.request.use(config => {
//     if (config.url.includes('/auth/refresh')) {
//         delete config.headers.Authorization
//         return config
//     }

//     const token = localStorage.getItem('accessToken')
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`
//     }

//     return config
// })


/* ===== Response interceptor ===== */
apiPrivate.interceptors.response.use(
    res => res,
    async error => {
        const originalRequest = error.config
        const status = error.response?.status
        const isAuth = localStorage.getItem('isAuthenticated') === 'true'

        if (
            originalRequest.url.includes('/auth/logout') ||
            originalRequest.url.includes('/auth/refresh')
        ) {
            return Promise.reject(error)
        }

        if (!isAuth || status !== 401 || originalRequest._retry) {
            return Promise.reject(error)
        }

        originalRequest._retry = true

        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({ resolve, reject })
            }).then(() => apiPrivate(originalRequest))
        }

        isRefreshing = true

        try {
            const res = await apiPrivate.post('/auth/refresh')
            const newToken = res.data.accessToken ?? res.data

            localStorage.setItem('accessToken', newToken)
            processQueue()

            return apiPrivate(originalRequest)
        } catch (err) {
            processQueue(err)

            localStorage.clear()
            window.location.href = '/login'

            return Promise.reject(err)
        } finally {
            isRefreshing = false
        }
    }
)

export default apiPrivate
